import { useDispatch, useSelector } from "react-redux";
import { useEffect, useState } from "react";
import { getReportingUseHangfireQueuing } from "../app/auth/store/reducers/system-configuration";
import { hasExportJobs,
  isReportExportLoading,
  showExportCompleteIndicator } from "../app/main/reportExport/reducers/reportExport.reducers";
import { getExportJobList } from "../app/main/reportExport/actions/reportExport.actions";

const useShouldShowReportExportDropDownButton = orgUnitId => {
  const dispatch = useDispatch();
  const reportingUseHangfireQueuing = useSelector(getReportingUseHangfireQueuing);
  const showIndicator = useSelector(showExportCompleteIndicator);
  const hasJobs = useSelector(hasExportJobs);
  const isLoading = useSelector(isReportExportLoading);
  const [shouldShow, setShouldShow] = useState(false);

  useEffect(() => {
    // If Hangfire exporting is disabled, we don't need to get the export job list
    // since the export job dropdown won't appear on screen
    if (!reportingUseHangfireQueuing) return;

    if (!orgUnitId) return;

    dispatch(getExportJobList(orgUnitId));
  }, [dispatch, reportingUseHangfireQueuing, orgUnitId]);

  useEffect(() => {
    // If hangfire queuing is disabled, always hide
    if (!reportingUseHangfireQueuing) {
      setShouldShow(false);
      return;
    }

    // Skip state updates while loading and return the previous value of shouldShow
    if (isLoading) {
      return;
    }

    // If showIndicator is true, it means the user just started exporting, so there must be an export job.
    // This condition is necessary because there is a timeframe where the export list is empty while loading,
    // and we need this showIndicator to indicate that the user just started exporting
    if (showIndicator) {
      setShouldShow(true);
      return;
    }

    // Update based on whether there are any export jobs
    setShouldShow(hasJobs);
  }, [reportingUseHangfireQueuing, isLoading, showIndicator, hasJobs, shouldShow]);

  return shouldShow;
};

export default useShouldShowReportExportDropDownButton;
